<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */
 -->

<template>
  <div class="expensa-audit-data">
    <code v-if="!open" class="expensa-audit-compact">{{ compact }}</code>
    <pre v-else class="expensa-audit-pretty">{{ pretty }}</pre>
    <oxd-button
      v-if="hasData"
      display-type="text"
      :label="
        open ? $t('expensa.audit_hide_data') : $t('expensa.audit_show_data')
      "
      @click="open = !open"
    />
  </div>
</template>

<script>
/**
 * Dati di un evento di audit: JSON compatto su una riga, espandibile.
 * Sempre testo (nessun v-html): il contenuto viene dall'API.
 */
export default {
  name: 'ExpensaAuditData',
  props: {
    data: {type: [Object, Array], default: null},
  },
  data() {
    return {open: false};
  },
  computed: {
    hasData() {
      return this.data !== null && this.data !== undefined;
    },
    compact() {
      return this.hasData ? JSON.stringify(this.data) : '—';
    },
    pretty() {
      return JSON.stringify(this.data, null, 2);
    },
  },
};
</script>

<style scoped lang="scss">
.expensa-audit-data {
  min-width: 0;
  width: 100%;
}
.expensa-audit-compact {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.75rem;
}
.expensa-audit-pretty {
  margin: 0;
  overflow-x: auto;
  font-size: 0.75rem;
}
</style>
